// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3mob5","image-container":"classes_image-container__rryeO","like-count":"classes_like-count__t_fib"};